import "../styles/PortfolioGrid.css";

import SowjanyaStudios from "../assets/Sowjanya_studios.png";
import C2A from "../assets/ctoa.png";
import MasterAbroad from "../assets/masterabroad.png";
import MayuInfra from "../assets/mayuinfra.png";
import { useNavigate } from "react-router-dom";
function PortfolioGrid() {

  const navigate=useNavigate();
  const projects = [
    {
      id: 1,
      image: SowjanyaStudios,
      title: "Sowjanya Studios",
      category: "Brand Identity, Outdoor Marketing",
    },
    {
      id: 2,
      image: C2A,
      title: "C2A",
      category: "Brand Identity, Outdoor Marketing",
    },
    {
      id: 3,
      image: MasterAbroad,
      title: "MASTERSABROAD",
      category: "Brand Identity",
    },
    {
      id: 4,
      image: MayuInfra,
      title: "MAYU INFRA",
      category: "Brand Identity, Outdoor Marketing",
    },
  ];

  return (
    <section className="portfolio-grid-section">
      <h2 className="portfolio-heading">View Our Work</h2>

      <p className="portfolio-category">Branding</p>

      <div className="portfolio-grid">
        {projects.map((project) => (
          <div className="project-card" key={project.id}>
            <div className="image-wrapper">
              <img src={project.image} alt={project.title} />
            </div>

            <h3>{project.title}</h3>

            <p>{project.category}</p>
          </div>
        ))}
      </div>

      {/* <button className="case-study-btn">
        View Case Studies
      </button> */}

      <div className="marketing-home-view">
      <button className="view-home-more-btn" onClick={()=>{navigate("/brandingcasestudy")}}>View Case Studies</button>
      </div>

    </section>
  );
}

export default PortfolioGrid;